import {gtmEcommerceOfferTypeMap} from "@pg-rp/common-types";

import {IRangeQuery} from "../../../../request/IRangeQuery";
import {hitGoogleTagManager} from "../../../../tracking/google_tag_manager/hit_google_tag_manager";
import {IGTMEcommerce} from "../../../../tracking/types/ecommerce/IGTMEcommerce";
import {IGTMEcommerceItem} from "../../../../tracking/types/ecommerce/IGTMEcommerceItem";
import {Currency} from "../../../../types/Currency";
import {OfferType} from "../../../types/OfferType";
import {IOfferArchivedData} from "../../../utils/is_offer_archived";
import {getGTMEcommerceItemStatus} from "../common/get_gtm_ecommerce_item_status";
import {getGtmEcommerceOfferAvailability, IGtmEcommerceOfferAvailabilityParams} from "../common/get_gtm_ecommerce_offer_availability";
import {getGtmEcommerceOfferItemBaseProps, IGtmEcommerceOfferItemBaseProps} from "../common/get_gtm_ecommerce_offer_item_base_props";
import {getGTMEcommerceOfferRegion, IGetGTMEcommerceOfferRegion} from "../common/get_gtm_ecommerce_offer_region";
import {getGTMEcommerceSpainParams, IGetGTMEcommerceSpainParams} from "../common/get_gtm_ecommerce_spain_params";

export interface IHitGTMOfferViewItemParams {
    offer: {
        type: OfferType;
        region: IGetGTMEcommerceOfferRegion;
        construction_date_range: IRangeQuery<string>;
        currency: Currency;
    } & IGtmEcommerceOfferItemBaseProps &
        IGetGTMEcommerceSpainParams & {
            configuration: IOfferArchivedData["configuration"] & IGtmEcommerceOfferAvailabilityParams["configuration"];
        };
}

export const hitGTMOfferViewItem = (params: IHitGTMOfferViewItemParams) => {
    const item = {
        ...getGtmEcommerceOfferItemBaseProps(params.offer),
        item_category: "investment",
        price: 1,
        quantity: 1,
        ...getGtmEcommerceOfferAvailability(params.offer),
        item_status: getGTMEcommerceItemStatus(params.offer),
        item_type: gtmEcommerceOfferTypeMap[params.offer.type],
        item_comissioning_date: params.offer.construction_date_range.upper || "na",
        variant: "na",
        ...getGTMEcommerceOfferRegion(params.offer.region),
        ...getGTMEcommerceSpainParams(params.offer.region.country, params.offer)
    } as IGTMEcommerceItem;

    const ecommerce: IGTMEcommerce = {
        currency: params.offer.currency === Currency.EURO ? "EUR" : "PLN",
        value: 1,
        items: [item]
    };

    hitGoogleTagManager({
        event: "view_item",
        ecommerce
    });
};
import {gtmEcommerceOfferTypeMap} from "@pg-rp/common-types";

import {IRangeQuery} from "../../../../request/IRangeQuery";
import {hitGoogleTagManager} from "../../../../tracking/google_tag_manager/hit_google_tag_manager";
import {IGTMEcommerce} from "../../../../tracking/types/ecommerce/IGTMEcommerce";
import {IGTMEcommerceItem} from "../../../../tracking/types/ecommerce/IGTMEcommerceItem";
import {Currency} from "../../../../types/Currency";
import {OfferType} from "../../../types/OfferType";
import {IOfferArchivedData} from "../../../utils/is_offer_archived";
import {getGTMEcommerceItemStatus} from "../common/get_gtm_ecommerce_item_status";
import {getGtmEcommerceOfferAvailability, IGtmEcommerceOfferAvailabilityParams} from "../common/get_gtm_ecommerce_offer_availability";
import {getGtmEcommerceOfferItemBaseProps, IGtmEcommerceOfferItemBaseProps} from "../common/get_gtm_ecommerce_offer_item_base_props";
import {getGTMEcommerceOfferRegion, IGetGTMEcommerceOfferRegion} from "../common/get_gtm_ecommerce_offer_region";
import {getGTMEcommerceSpainParams, IGetGTMEcommerceSpainParams} from "../common/get_gtm_ecommerce_spain_params";

export interface IHitGTMOfferViewItemParams {
    offer: {
        type: OfferType;
        region: IGetGTMEcommerceOfferRegion;
        construction_date_range: IRangeQuery<string>;
        currency: Currency;
    } & IGtmEcommerceOfferItemBaseProps &
        IGetGTMEcommerceSpainParams & {
            configuration: IOfferArchivedData["configuration"] & IGtmEcommerceOfferAvailabilityParams["configuration"];
        };
}

export const hitGTMOfferViewItem = (params: IHitGTMOfferViewItemParams) => {
    const item = {
        ...getGtmEcommerceOfferItemBaseProps(params.offer),
        item_category: "investment",
        price: 1,
        quantity: 1,
        ...getGtmEcommerceOfferAvailability(params.offer),
        item_status: getGTMEcommerceItemStatus(params.offer),
        item_type: gtmEcommerceOfferTypeMap[params.offer.type],
        item_comissioning_date: params.offer.construction_date_range.upper || "na",
        variant: "na",
        ...getGTMEcommerceOfferRegion(params.offer.region),
        ...getGTMEcommerceSpainParams(params.offer.region.country, params.offer)
    } as IGTMEcommerceItem;

    const ecommerce: IGTMEcommerce = {
        currency: params.offer.currency === Currency.EURO ? "EUR" : "PLN",
        value: 1,
        items: [item]
    };

    hitGoogleTagManager({
        event: "view_item",
        ecommerce
    });
};
